module.exports = __webpack_public_path__ + "static/img/main-03.4fb2723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/main-03.jpg
// module id = bhXd
// module chunks = 1